import React from 'react';

import {generateKeyForSystemField} from './ChipPopoverContentUtils';

export interface ChipPopoverInfoField {
  /** Function to generate key, which must be unique. It should not be the same as "label" in case of name
   * clashes particularly with user defined schema fields. By default, this just calls `generateKeyForSystemField`
   * to prepend `systemField-` to the label. When used for schema tags, this _must_ be overridden to
   * leverage `generateKeyForSchemaField` instead. */
  generateStableKey?: () => string;
  /** Display label to render for the field. */
  label: string;
  /** Value of the field. */
  value?: string | JSX.Element | null;
}

export interface ChipPopoverInfo {
  fields: Array<ChipPopoverInfoField>;
}

export default function ChipPopoverContent(props: {info: ChipPopoverInfo}): JSX.Element {
  // We use the `style` attribute here because bootstrap popovers and aphrodite don't play well together.
  // See https://benchling.slack.com/archives/C7X6N0QNN/p1599176730002100
  return (
    <table style={{borderCollapse: 'separate', borderSpacing: '5px'}}>
      <tbody>
        {props.info.fields.map(({generateStableKey, label, value}) =>
          value ? (
            <tr key={generateStableKey != null ? generateStableKey() : generateKeyForSystemField(label)}>
              <td role="rowheader">
                <b>{label}</b>
              </td>
              <td style={{paddingLeft: '1em', wordBreak: 'break-word'}}>{value}</td>
            </tr>
          ) : null
        )}
      </tbody>
    </table>
  );
}
